export default {

    getSelectedM0CheckListId: state => state.selectedM0CheckListId,
    getSelectedRoomId: state => state.selectedRoomId,
    getSelectedEditHistoryId: state => state.selectedEditHistoryId,
    getRoomDatas: state => state.roomDatas,
    getEditHistoryListMap: state => state.editHistoryListMap,
}